import React from 'react';
import { BankBalances } from './balances/BankBalances';
import { CashTransactionSection } from './transactions/CashTransactionSection';
import { CashflowForecastSection } from './forecast/CashflowForecastSection';
import { mockBanks, mockAccounts, mockDailyBalances } from '../../data/mockBankData';

export function CashManagement() {
  return (
    <div className="space-y-6 p-8">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Cash Management</h1>
        <p className="text-gray-500 mt-1">Manage your cash positions and transactions</p>
      </div>

      <BankBalances
        banks={mockBanks}
        accounts={mockAccounts}
        dailyBalances={mockDailyBalances}
      />

      <CashTransactionSection />

      <CashflowForecastSection />
    </div>
  );
}